<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<div class="ded-center">For Marla</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?e5bec45a